import CustomFormEdit from "@/views/customform/CustomFormEdit.vue"

const base = "/form"

export default [
    {
        path: base + "/:uuid",
        name: "customformview",
        props: true,
        component: CustomFormEdit // TODO View.vue
    },
    {
        path: base + "/:uuid/edit",
        name: "customformedit",
        props: true,
        component: CustomFormEdit
    },
    {
        path: base + "/new/:formTemplateId",
        name: "newcustomform",
        props: (route: any) => ({ new: true, formTemplateId: route.params.formTemplateId, jobUuid: route.query.jobUuid }),
        component: CustomFormEdit
    }
]
